import { render, staticRenderFns } from "./AboutTitle.vue?vue&type=template&id=7f6a3e83&scoped=true"
import script from "./AboutTitle.vue?vue&type=script&lang=js"
export * from "./AboutTitle.vue?vue&type=script&lang=js"
import style0 from "./AboutTitle.vue?vue&type=style&index=0&id=7f6a3e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a3e83",
  null
  
)

export default component.exports